import React from 'react';

import PropTypes from 'prop-types';

import { Container } from './styles';

function FotoNFLayout({ children }) {
  return <Container>{children}</Container>;
}

FotoNFLayout.propTypes = {
  children: PropTypes.element.isRequired,
};

export default FotoNFLayout;
